import React, { useEffect, useState } from 'react';
import { Flex } from 'antd';
import './index.scss';
import classNames from 'classnames';
interface Props {
  selected: boolean;
  cockpitUserName: string;
  cockpitNumber: string;
  cockpitType: string;
  issueTotal: number;
  setSelectedCockpit: AnyFunc;
}
const Cockpit = (props: Props) => {
  const {
    selected,
    cockpitNumber,
    cockpitUserName,
    cockpitType,
    issueTotal,
    setSelectedCockpit,
  } = props;
  return (
    <>
      <div
        key={cockpitNumber}
        className='cockpit'
        onClick={() => {
          setSelectedCockpit({
            cockpitNumber: cockpitNumber,
            cockpitUserName: cockpitUserName,
            cockpitType: cockpitType,
            issueTotal: issueTotal,
          });
        }}
      >
        <Flex
          vertical
          justify='center'
          align='center'
          style={{ width: '95px' }}
        >
          <div
            className={classNames('', {
              'cockpit-number-selected': selected,
              'cockpit-number': !selected,
            })}
          >
            {cockpitNumber}
          </div>
          <div
            className={classNames('', {
              'cockpit-icon-selected': selected,
              'cockpit-icon': !selected,
            })}
          />
          <div className='cockpit-user'>
            <span>
              {' '}
              <svg
                className='icon'
                style={{
                  width: '1em',
                  height: '1em',
                  verticalAlign: 'middle',
                  fill: 'currentColor',
                  overflow: 'hidden',
                }}
                viewBox='0 0 1024 1024'
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                p-id='1456'
              >
                <path
                  d='M512 512c123.776 0 224-100.224 224-224S635.776 64 512 64a223.936 223.936 0 0 0-224 224C288 411.776 388.224 512 512 512z m0 64c-149.504 0-448 85.76-448 256v128h896v-128c0-170.24-298.496-256-448-256z'
                  fill='#fff'
                  p-id='1457'
                ></path>
              </svg>
              {cockpitUserName}
            </span>
          </div>
        </Flex>
      </div>
    </>
  );
};
export default React.memo(Cockpit);
